import Model from '@/models/BaseModel'
import Period from '@/models/Period'
import i18n from '@/plugins/i18n'
export default class Bill extends Model {
    resourceName() {
        return 'bills'
    }

    fields() {
        return [
            'id',
            'reseller_id',
            'payment_gateway_id',
            'discount',
            'due_at',
            'interest',
            'invoice_url',
            'month',
            'paid_at',
            'status',
            'totalValue',
            'url',
            'value',
            'year',
            'archived',
            'has_negotiation',
        ]
    }

    relationships() {
        return {
            periods: new Period(),
        }
    }

    dates() {
        return {
            paid_at: 'YYYY-MM-DD',
            due_at: 'YYYY-MM-DD',
        }
    }

    computed() {
        return {
            reference(bill) {
                const referenceDate = `${bill.month}/${bill.year}`
                return bill.month < 10 ? '0' + referenceDate : referenceDate
            },
            formattedTotalValue(bill) {
                return i18n.n(bill.totalValue, 'currency')
            },
            formattedValue(bill) {
                return i18n.n(bill.value, 'currency')
            },
            formattedDiscount(bill) {
                return i18n.n(bill.discount, 'currency')
            },
            formattedInterest(bill) {
                return i18n.n(bill.interest, 'currency')
            },
            formattedPaidAt(bill) {
                return bill.paid_at.isValid()
                    ? i18n.d(bill.paid_at, 'datetime')
                    : null
            },
            formattedDueAt(bill) {
                return bill.due_at.isValid()
                    ? i18n.d(bill.due_at, 'short')
                    : null
            },
        }
    }

    get tableColumns() {
        return [
            {
                text: i18n.t('resources.bill.attributes.reference'),
                value: 'reference',
                sortable: false,
            },
            {
                text: i18n.t('resources.bill.attributes.due_at'),
                value: 'formattedDueAt',
                sortable: false,
            },
            {
                text: i18n.t('resources.bill.attributes.totalValue'),
                value: 'formattedTotalValue',
                sortable: false,
            },
            {
                text: i18n.t('resources.bill.attributes.paid_at'),
                value: 'formattedPaidAt',
                sortable: false,
            },
            {
                text: 'Ações',
                value: 'action',
                sortable: false,
                width: 150,
                align: 'end',
            },
        ]
    }
}
